var _style, _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.bg { fill: var(--bg); }\n\t\t.fg { fill: var(--fg); }\n\t")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    className: "bg"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353 207.5C353 287.857 287.857 353 207.5 353C127.143 353 62 287.857 62 207.5C62 127.143 127.143 62 207.5 62C287.857 62 353 127.143 353 207.5ZM99.9901 207.5C99.9901 266.876 148.124 315.01 207.5 315.01C266.876 315.01 315.01 266.876 315.01 207.5C315.01 148.124 266.876 99.9901 207.5 99.9901C148.124 99.9901 99.9901 148.124 99.9901 207.5Z",
    className: "fg"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M207.5 123C185.089 123 163.596 131.903 147.749 147.749C131.903 163.596 123 185.089 123 207.5L147.598 207.5C147.598 191.613 153.909 176.377 165.143 165.143C176.377 153.909 191.613 147.598 207.5 147.598V123Z",
    className: "fg"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M297.25 348.951L387.026 438.726C401.274 452.974 424.375 452.974 438.623 438.726C452.871 424.477 452.871 401.376 438.623 387.128L348.871 297.376C335.657 318.117 318.004 335.755 297.25 348.951Z",
    className: "fg"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.bdd654657ca870834cc31baade149459.svg";
export { ForwardRef as ReactComponent };